module.exports = __webpack_public_path__ + "static/mobile-crab-66169f7ec2421cb6cd9ddb918c615a71.png";